module.exports = __webpack_public_path__ + "img/call_silent.5655f9f0.svg";